import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

import { fetchTestRuns } from '../api/hardware-tests.api'
import { TestRunsModel } from '../models'
import { useEffect } from 'react'
import { usePortalQuery } from 'src/Libs/api'

type DataReturnType = [TestRunsModel | null, () => void, boolean, boolean]

interface UseHardwareTestRunDataParams {
  storageId: number
  pageSize: number
  offset?: number
  onSuccess?: (resultData: TestRunsModel | null) => void
}

/**
 * Hook to get all test runs for a system
 */
export const useHardwareTestRunData = ({ offset, pageSize, storageId, onSuccess }: UseHardwareTestRunDataParams): DataReturnType => {
  const authFetch = useAuthFetchWithResponse()

  const fetchTestRunsQueryFn = async (): Promise<TestRunsModel | null> => {
    const { error, hasErrors, value } = await fetchTestRuns({
      authFetch,
      pageSize,
      storageId,
      offset,
    })

    if (hasErrors) {
      throw error || new Error('An unexpected error occurred when fetching test runs')
    }

    return value
  }

  const { data, isLoading, isError, refetch } = usePortalQuery({
    queryKey: ['hardware-tests', 'storages', storageId, 'tests', 'runs', pageSize, offset],
    queryFn: fetchTestRunsQueryFn,
    enabled: !!storageId && !!pageSize,
  })

  useEffect(() => onSuccess?.(data ?? null), [data, onSuccess])

  return [data || null, refetch, isLoading, isError]
}
